export const ActionTypes = {
  APPLY_FOR_CREDIT_SUBMIT_REQUEST: "APPLY_FOR_CREDIT_SUBMIT_REQUEST",
  APPLY_FOR_CREDIT_SUBMIT_SUCCESS: "APPLY_FOR_CREDIT_SUBMIT_SUCCESS",
  APPLY_FOR_CREDIT_SUBMIT_FAILURE: "APPLY_FOR_CREDIT_SUBMIT_FAILURE",

  APPLY_FOR_CREDIT_CLEAN_UP: "APPLY_FOR_CREDIT_CLEAN_UP",
};
